<template>
  <div>
    <navbarhot></navbarhot>
    <div class="container" style="margin-top: 3rem;">
      <h2>Step 3: Switch to your Ubuntu Laptop</h2>
      <p>On your freshly installed Ubuntu laptop open <b>Firefox</b> and type the following URL into the address bar and click <b>Enter</b>.</p>
      <code>one.yeticold.com</code>
    </div>
  </div>
</template>
<script>
import navbarhot from './navbarhot'
export default {
  components: {
    navbarhot
  }
}
</script>



// WEBPACK FOOTER //
// src/components/YHSetup3.vue